export default __webpack_public_path__ + "static/media/Wallet.3f30987b.svg";